<template>
  <div class="gift-content">
    <div
      :class="
        data.items.length == 2
          ? 'two-gifts'
          : data.items.length == 3
          ? 'three-gifts'
          : ''
      "
    >
      <div v-for="(product, index) in data.items" :key="product.id">
        <img
          v-if="data.items.length != 3"
          class="gift-img-only"
          :src="getUrlImage(product)"
        />
        <img
          v-if="data.items.length == 3"
          class="gift-imgs"
          @mouseover="imgSelected = index"
          @mouseleave="imgSelected = 1"
          :class="imgSelected == index ? 'img-selected' : 'img-not-selected'"
          :src="getUrlImage(product)"
        />
      </div>
    </div>

    <div v-for="product in data.items" :key="product.id" class="gift-title">
      {{ product.gift_name }}
    </div>

    <a
      class="link-shopping"
      v-if="linkToShopping"
      :href="linkToShopping"
      target="_blank"
    >
      Buscar no Shopping Casar.com <img :src="arrowRightLink" />
    </a>

    <div class="gift-details">
      <div><strong>Comprado por: </strong> {{ data.guest }}</div>
      <div><strong>Data da compra: </strong> {{ data.date }}</div>
      <div style="color: #e583a2">
        <strong>Valor do presente: </strong>
        {{ data.value | currency }}
      </div>
      <div>
        <strong>Valor da taxa: </strong>
        {{ data.rate_amount | currency }}
      </div>
      <div>
        <strong>Valor recebido: </strong>
        {{ data.couple_amount | currency }}
      </div>
      <div v-if="shouldShowFlexibleRepassExtraData">
        <strong>Meio de pagamento: </strong>
        {{ data.payment_method }}
      </div>
      <div v-if="shouldShowFlexibleRepassExtraData">
        <strong>Tempo do recebimento: </strong>
        {{ data.transfer_deadline }}
      </div>
      <div v-if="dateTransferedAt">
        <strong>Repasse: </strong>{{ dateTransferedAt }} (até às 23h59)
      </div>
      <div><strong>Status: </strong>{{ data.transfer_status }}</div>

      <div class="link-wallet">
        <a href="/carteira/">Acessar Carteira <img :src="arrowRight" /></a>
      </div>
    </div>
    <div class="mobile-guest-section">
      <div class="message-section">
        <img :src="messageReceivedIcon" />
        <div class="message-guest-name">
          Mensagem recebida de <br />{{ data.guest }}
        </div>
        <div class="message-text">
          {{ data.guest_message }}
        </div>
      </div>
      <div class="message-guest-thanks">Agradecer presente por:</div>
      <div class="share-icons">
        <div class="share-icons-link" @click="messageWhatsapp()">
          <img :src="whatsappIcon" style="width: 20px" />
        </div>
        <div class="share-icons-link" @click="messageEmail()">
          <img :src="emailIcon" style="width: 23px" />
        </div>
      </div>
      <div class="check-thanks">
        Marcar como agradecido
        <b-switch
          @input="thankGift"
          class="switch-thanks"
          v-model="grateful"
        ></b-switch>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import GiftsApi from '@/lib/api/Gifts'

import arrowRight from '@/assets/img/chevron-right.svg'
import arrowRightLink from '@/assets/img/chevron-right-link.svg'
import messageReceivedIcon from '@/assets/img/gift-message.svg'
import whatsappIcon from '@/assets/img/whatsapp.svg'
import emailIcon from '@/assets/img/email.svg'

const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  data() {
    return {
      arrowRight,
      arrowRightLink,
      messageReceivedIcon,
      whatsappIcon,
      emailIcon,
      imgSelected: 1,
      grateful: false,
      shouldShowFlexibleRepassExtraData: false
    }
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      wedId: 'app/getWedId',
      logonToken: 'app/logonToken',
    }),
    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },
    linkToShopping() {
      return this.data?.items[0]?.gift_link_shopping ?? undefined
    },

    dateTransferedAt() {
      if (this.data.transfered_at) return this.data.transfered_at
      const transferedAt = new Date(this.data.items[0].created_at_utc)
      transferedAt.setDate(transferedAt.getDate() + 3)
      return transferedAt.toLocaleDateString('pt-BR')
    },
  },

  mounted() {
    this.getFlexibleRepassEnabled()
    this.grateful = this.data?.grateful
  },

  methods: {
    getUrlImage(gift) {
      if (gift.img_user == '1') {
        return (
          `${API_LEGACY_URL}/dados/sitenoivos/wed${this.wedId}/presentes/` +
          gift.img
        )
      } else {
        return `${API_LEGACY_URL}/img/presentes/` + gift.img
      }
    },
    messageWhatsapp() {
      var message =
        this.data.guest +
        ', adoramos seu presente! %0D%0A %0D%0A Obrigado! %0D%0A %0D%0A ' +
        this.wedSiteInfo.noivo1_nome +
        ' e ' +
        this.wedSiteInfo.noivo2_nome
      window.open('whatsapp://send?text=' + message, '_blank')
    },
    messageEmail() {
      var message =
        'mailto:' +
        this.data.guest_email +
        '?&body=' +
        this.data.guest +
        ', adoramos seu presente! %0D%0A %0D%0A Obrigado! %0D%0A %0D%0A ' +
        this.wedSiteInfo.noivo1_nome +
        ' e ' +
        this.wedSiteInfo.noivo2_nome
      window.open(message, '_blank')
    },

    async thankGift() {
      const giftsApi = new GiftsApi(this.logonToken)
      var dataThanks = {
        gift: parseInt(this.data.id),
        status: this.grateful ? 1 : 0,
      }

      giftsApi.thankGift(dataThanks).then((response) => {
        if (response.data.success)
          this.$emit('gratefulChanged', {
            id: this.data.id,
            grateful: this.grateful,
          })
      })
    },

    getFlexibleRepassEnabled() {
      const giftsApi = new GiftsApi(this.logonToken)

      giftsApi
        .getTaxes()
        .then((response) => {
          if(response.data.group != null){
            this.shouldShowFlexibleRepassExtraData = true;
          }
        })
        .catch((error) => console.error(error))
    },
  },
}
</script>

<style lang="scss" scoped>
.two-gifts {
  display: inline-flex;
  gap: 20px;
}

.img-selected {
  width: 128px !important;
  height: 128px !important;
  border-radius: 16px;
  z-index: 4;
  position: relative;
}

.img-not-selected {
  width: 96px;
  height: 96px;
  border-radius: 16px;
  z-index: 1;
  position: relative;
  transition: 0.15s all ease-in-out;

  @media (max-width: $mobile) {
    transition: 0.1s all ease-in-out;
  }
}

.three-gifts {
  display: inline-flex;
  align-items: center;
  min-height: 135px;

  div:first-child {
    margin-right: -12px;

    img {
      width: 96px;
      height: 96px;
    }
  }

  div:nth-child(2) {
    img {
      z-index: 3;
    }
  }

  div:last-child {
    margin-left: -12px;
    img {
      width: 96px;
      height: 96px;
    }
  }
}
.gift-content {
  text-align: center;
  margin-top: 24px;
}
.gift-img-only {
  width: 128px;
  height: 128px;
  border-radius: 16px;
  object-fit: cover;
}

.gift-imgs {
  transition: 0.15s all ease-in-out;
  object-fit: cover;
  @media (max-width: $mobile) {
    transition: 0.1s all ease-in-out;
  }
}

.gift-title {
  margin-top: 16px;
  font-size: 16px;
  font-weight: 700;
  color: $neutral;
  padding-right: 55px;
  padding-left: 55px;
}

.link-shopping {
  margin-top: 8px;
  color: $primary;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  justify-content: center;
}
.gift-details {
  margin-top: 24px;
  background-color: $neutrallightest;
  border-radius: 16px;
  margin-right: 16px;
  margin-left: 16px;
  padding: 16px;
  text-align: left;
  color: $neutral;
  line-height: 28px;

  p,
  strong {
    color: $neutral;
  }

  .link-wallet {
    margin-top: 16px;
    color: #3dafb0;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    justify-content: left;
    cursor: pointer;

    a {
      display: flex;
    }
  }
}

.message-section {
  margin-top: 24px;
  padding: 16px;

  .message-guest-name {
    margin-top: 8px;
    color: $neutraldarkest;
    font-weight: 700;
    font-size: 16px;
  }
  .message-text {
    margin-top: 24px;
    color: $neutral;
    font-weight: 400;
    text-align: justify;
  }
}
.message-guest-thanks {
  margin-top: 24px;
  font-weight: 700;
  font-size: 16px;
  color: $neutraldarkest;
  text-align: left;
  margin-left: 16px;
}

.share-icons {
  margin-top: 24px;
  display: flex;
  gap: 16px;
  margin-left: 16px;
  margin-right: 16px;
}

.share-icons-link {
  border: 1px solid #dde7f1;
  border-radius: 16px;
  height: 56px;
  width: 50%;
  justify-content: center;
  display: flex;
}

.check-thanks {
  margin-top: 26px;
  margin-bottom: 34px;
  display: flex;
  justify-content: center;
  color: $neutral;

  .switch-thanks {
    margin-left: 8px;
  }
}

.mobile-guest-section {
  @media (min-width: 768px) {
    display: none;
  }
}
</style>
